import src from "IMAGE";
export default { src, width: 121, height: 32, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ACEjKUksLzhZKSszTSotNVErLTVQJigwSSQmLUUtLzhYAKeoqhSwsbUlrq+yIKmqrRaoqasTpqepEKWmpw6nqKoOYtMXSVN7APwAAAAASUVORK5CYII="};
